/* VAULT - product.js — variant selection */
(function(){
  'use strict';
  if(!window.Vault) return;
  var V = window.Vault;

  var productScript = document.querySelector('script[id^="product-json-"]');
  if(!productScript) return;
  var product;
  try { product = JSON.parse(productScript.textContent); } catch(e){ return; }
  if(!product || !product.variants) return;

  var form = V.$('.product-form');
  if(!form) return;

  function getSelectedOptions(){
    var pills = V.$$('[data-variant-pill]', form);
    var byOption = {};
    pills.forEach(function(p){
      if(p.classList.contains('is-selected')){
        byOption[p.getAttribute('data-option-index')] = p.getAttribute('data-value');
      }
    });
    var opts = [];
    for(var i = 0; i < product.options.length; i++){
      opts.push(byOption[i] || null);
    }
    return opts;
  }

  function findVariant(opts){
    return product.variants.find(function(v){
      return v.options.every(function(o,i){ return o === opts[i]; });
    });
  }

  // Mark option pills that would lead to a sold-out / nonexistent combination,
  // given the currently-selected values of the *other* options. Runs after every
  // change so feedback stays accurate as the shopper narrows their choice.
  function updatePillAvailability(){
    var selected = getSelectedOptions();
    V.$$('[data-variant-pill]', form).forEach(function(pill){
      var optIdx = parseInt(pill.getAttribute('data-option-index'), 10);
      if(isNaN(optIdx)) return;
      // Build a candidate selection: this pill's value at its option index,
      // keeping the other currently-selected values.
      var candidate = selected.slice();
      candidate[optIdx] = pill.getAttribute('data-value');
      var match = product.variants.find(function(v){
        return v.options.every(function(o,i){
          // Ignore option slots we haven't pinned yet (null) except this one.
          if(i === optIdx) return o === candidate[optIdx];
          if(candidate[i] == null) return true;
          return o === candidate[i];
        });
      });
      var unavailable = !match || match.available === false;
      pill.classList.toggle('is-unavailable', unavailable);
    });
  }

  function updateUI(variant){
    if(!variant){
      var atc = V.$('[data-atc]');
      if(atc){ atc.disabled = true; }
      var txt = V.$('[data-atc-text]'); if(txt) txt.textContent = 'Unavailable';
      return;
    }
    // Hidden variant id
    var idIn = V.$('[data-variant-id]'); if(idIn) idIn.value = variant.id;
    // Price
    var p = V.$('[data-price]'); if(p) p.textContent = V.formatMoney(variant.price);
    var c = V.$('[data-compare]');
    var sv = V.$('[data-save]');
    if(variant.compare_at_price && variant.compare_at_price > variant.price){
      if(c){ c.textContent = V.formatMoney(variant.compare_at_price); c.style.display = ''; }
      if(sv){
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        sv.textContent = 'Save ' + pct + '%';
        sv.style.display = '';
      }
    } else {
      if(c) c.style.display = 'none';
      if(sv) sv.style.display = 'none';
    }
    // Stock
    var stockWrap = V.$('[data-stock-wrapper]');
    if(stockWrap){
      if(variant.available){
        stockWrap.innerHTML = '<span class="stock-pill stock-pill--in"><span class="stock-pill__dot"></span>In stock · Ready to ship</span>';
      } else {
        stockWrap.innerHTML = '<span class="stock-pill stock-pill--out"><span class="stock-pill__dot"></span>Currently sold out</span>';
      }
    }
    // ATC
    var atc = V.$('[data-atc]');
    var atcText = V.$('[data-atc-text]');
    if(atc){ atc.disabled = !variant.available; }
    if(atcText){
      if(variant.available){
        atcText.textContent = 'Add to cart · ' + V.formatMoney(variant.price);
      } else {
        atcText.textContent = 'Sold out';
      }
    }
    // Sticky ATC: keep price, compare, button text, and disabled state in sync
    var stPrice = V.$('[data-sticky-price]');
    if(stPrice) stPrice.textContent = V.formatMoney(variant.price);
    var stCompare = V.$('[data-sticky-compare]');
    if(stCompare){
      if(variant.compare_at_price && variant.compare_at_price > variant.price){
        stCompare.textContent = V.formatMoney(variant.compare_at_price);
        stCompare.style.display = '';
      } else {
        stCompare.style.display = 'none';
      }
    }
    var stStock = V.$('[data-sticky-stock]');
    if(stStock) stStock.style.display = variant.available ? '' : 'none';
    var stBtn = V.$('[data-sticky-atc-btn]');
    var stBtnText = V.$('[data-sticky-atc-text]');
    if(stBtn) stBtn.disabled = !variant.available;
    if(stBtnText){
      stBtnText.textContent = variant.available
        ? 'Add — ' + V.formatMoney(variant.price)
        : 'Sold out';
    }
    // Featured media swap
    if(variant.featured_media){
      var slides = V.$$('[data-gallery-slides] [data-media-id]');
      var idx = slides.findIndex(function(s){ return s.getAttribute('data-media-id') == variant.featured_media.id; });
      if(idx >= 0){
        slides.forEach(function(s,i){ s.classList.toggle('is-active', i === idx); });
        var thumbs = V.$$('[data-thumb]');
        thumbs.forEach(function(t,i){ t.classList.toggle('is-active', i === idx); });
        var cur = V.$('[data-gallery-current]');
        if(cur) cur.textContent = (idx + 1);
      }
    }
    // URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e){}
  }

  function onPillClick(e){
    var pill = e.target.closest('[data-variant-pill]');
    if(!pill) return;
    if(pill.classList.contains('is-unavailable')) return;
    var optIdx = pill.getAttribute('data-option-index');
    // Deselect siblings
    V.$$('[data-variant-pill][data-option-index="' + optIdx + '"]', form).forEach(function(p){
      p.classList.remove('is-selected');
    });
    pill.classList.add('is-selected');
    // Update display label
    var display = V.$('[data-option-display="' + optIdx + '"]');
    if(display) display.textContent = pill.getAttribute('data-value');
    // Recompute variant
    var opts = getSelectedOptions();
    var variant = findVariant(opts);
    updateUI(variant);
    updatePillAvailability();
  }

  form.addEventListener('click', onPillClick);

  // Initial pass so any already-sold-out options are flagged on page load.
  updatePillAvailability();
})();
